// removed by extract-text-webpack-plugin
module.exports = {"page":"_2d-79UlR9ykYv6PUJIJOXc","title":"_3yKciMrjlX3AtBJboJp7Sz","paper":"_1-4kG6UpfZf70gNvXyGLDS"};


//////////////////
// WEBPACK FOOTER
// ./src/Pages/SignedOutHomePage/SignedOutHomePage.css
// module id = 670
// module chunks = 3